import UserAuthStore from "../../store/userStore";
import ENDPOINTS from "../../api/endpoints";
import api from "../../api";

export const getChatModelInfo = async (chat_id, space) => {
  const { user, orgId } = UserAuthStore.getState();

  const response = await api({
    method: "GET",
    url: ENDPOINTS.CHAT_MODEL_INFO(chat_id, user?.uid, orgId, space?.space_id),
  });

  const { data, model_id, model_name, uid } = response.data;
  const persistedModelId = data?.model_id || (space?.space_id ? model_id : null);
  const persistedModelName = data?.model_name || (space?.space_id ? model_name : null);

  return {
    owner_id: user?.uid,
    ...data,
    model_id,
    model_name,
    persisted_model_id: persistedModelId,
    persisted_model_name: persistedModelName,
    uid,
  };
};
